<script setup>
import { computed } from 'vue';
import BaseNode from './BaseNode.vue';
import OutputRow from './OutputRow.vue';

const props = defineProps({
  id: { type: String, required: true },
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const config = computed(() => props.data.config || {});
const mediaTypeKey = computed(() =>
  (config.value.media_type || 'image').toUpperCase()
);
</script>

<template>
  <BaseNode
    type="media"
    :title="data.title"
    :selected="selected"
    :has-error="!config.media_asset_id"
  >
    <p class="mb-0.5">
      {{ $t('FLOWS.BUILDER.PANEL.MEDIA_TYPE') }}:
      {{ $t(`FLOWS.BUILDER.MEDIA_TYPES.${mediaTypeKey}`) }}
    </p>
    <p class="mb-0.5 truncate">
      {{ $t('FLOWS.BUILDER.PANEL.MEDIA_FILE') }}:
      {{ config.filename || $t('FLOWS.BUILDER.CANVAS.NO_MEDIA') }}
    </p>
    <p v-if="config.caption && config.media_type !== 'audio'" class="mb-1 line-clamp-2 text-n-slate-10">
      {{ config.caption }}
    </p>
    <div class="border-t border-n-weak pt-1">
      <OutputRow handle-id="next" :label="$t('FLOWS.BUILDER.CANVAS.NEXT_OUTPUT')" />
      <OutputRow handle-id="fallback" :label="$t('FLOWS.BUILDER.CANVAS.ERROR_OUTPUT')" muted />
    </div>
  </BaseNode>
</template>
